import { render, staticRenderFns } from "./memoryInfo.vue?vue&type=template&id=478117c1&"
import script from "./memoryInfo.vue?vue&type=script&lang=js&"
export * from "./memoryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports